import * as React from 'react';
import Waves from '../waves';
import { RoundScaleButtonStyle, RoundScaleIcon, RoundScaleText } from './scale';

interface Props {
  Icon?: React.ComponentType;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  mood?: string;
  size?: string;
  diameter?: number;
  animate: boolean;
  text?: string;
  id?: string;
}

const RoundScaleButtonComponent: React.FC<Props> = (props) => {
  const { Icon, onClick, mood, size, diameter, animate, text, id } = props;
  return (
    <RoundScaleButtonStyle
      onClick={onClick}
      {...{ mood, animate, size, diameter }}
      id={id}
    >
      <RoundScaleIcon fill={mood ? 'white' : 'gray'}>
        {Icon ? <Icon /> : null}
      </RoundScaleIcon>
      <RoundScaleText color={mood ? 'white' : 'gray'} font="Medium">
        {text}
      </RoundScaleText>
      <Waves color={mood ? 'white' : 'turquoise'} />
    </RoundScaleButtonStyle>
  );
};

export const RoundScaleButton = React.memo(RoundScaleButtonComponent);
